var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessGreenCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 16C32.5 24.8366 25.3366 32 16.5 32C7.66344 32 0.5 24.8366 0.5 16C0.5 7.16344 7.66344 0 16.5 0C25.3366 0 32.5 7.16344 32.5 16ZM23.0118 13.623L20.6548 11.266L14.7222 17.1986L12.3452 14.8215L9.98816 17.1786L13.5437 20.7341L14.7222 21.9126L15.9007 20.7341L23.0118 13.623Z",
    fill: "#4CB669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessGreenCircle);
export default __webpack_public_path__ + "static/media/success-green-circle.66e97bd53efd6a67e0200f5cb035dd9b.svg";
export { ForwardRef as ReactComponent };